import clsx from 'clsx';

//utils
import { mixPanelSchedulerNewPost } from '@/utils/mixpanel/schedulerEvents';

import PropTypes from 'prop-types';

// Components
import Icon from '@/components/base/Icon';
import Tooltip from '@/components/base/Tooltip';

const slotStyles = {
    default: {
        past: 'bg-icoGray-300 dark:bg-icoDarkMode-goudron',
        current:
            'bg-icoGray-300 dark:bg-icoDarkMode-goudron hover:bg-icoGray-400 dark:hover:bg-icoDarkMode-goudron/40',
        content: null
    },
    not_editable: {
        past: 'bg-icoGray-300 dark:bg-icoDarkMode-goudron',
        current: 'bg-icoGray-300 dark:bg-icoDarkMode-goudron cursor-default pointer-events-none',
        content: null
    },
    followers_online: {
        past: 'bg-icoBlue-100 dark:bg-icoBlue/20',
        current: 'bg-icoBlue-100 dark:bg-icoBlue/20 hover:bg-icoBlue-200 dark:hover:bg-icoBlue/40',
        content: <Icon icon="followers" className="text-sm text-icoBlue group-hover:hidden" />
    },
    best_time_to_post: {
        past: 'bg-icoYellow-100 dark:bg-icoYellow/20',
        current:
            'bg-icoYellow-100 dark:bg-icoYellow/20 hover:bg-icoYellow-200 dark:hover:bg-icoYellow/40',
        content: <Icon icon="star" className="text-sm text-icoYellow group-hover:hidden" />
    }
};

const TimeSlotIcon = ({ isActive, count }) => {
    if (!isActive) {
        return null;
    }

    return (
        <span
            className="dark:hover:bg-ico absolute right-0 top-0 rounded-bl-md rounded-tr-m bg-icoRed-100 p-1 text-icoRed dark:bg-icoDarkMode-anthracite dark:text-icoDarkMode-red"
            data-testid="time-slot-icon">
            <div className="flex items-center space-x-1 text-8">
                <Icon icon="likes-on" />
                {count > 1 ? <span>{count}</span> : null}
            </div>
        </span>
    );
};

TimeSlotIcon.propTypes = {
    count: PropTypes.number,
    isActive: PropTypes.bool
};

const EmptySlot = ({
    isPastSlot,
    hour,
    events,
    tooltipContent,
    onClick = () => {},
    notEditable = false
}) => {
    const getType = () => {
        if (events.best_time_to_post) {
            return 'best_time_to_post';
        } else if (events.followers_online) {
            return 'followers_online';
        } else if (notEditable) {
            return 'not_editable';
        }
        return 'default';
    };

    const type = getType();

    if (isPastSlot) {
        return (
            <div className="flex h-12 w-full p-0.5">
                <div
                    data-testid="empty-slot-past"
                    className={clsx(
                        'relative flex w-full items-center justify-center overflow-hidden rounded-md opacity-40',
                        slotStyles[type].past
                    )}>
                    {slotStyles[type].content}
                    <TimeSlotIcon isActive={events.time_slot} count={events.time_slot_count} />
                </div>
            </div>
        );
    }

    return (
        <Tooltip content={tooltipContent}>
            <div className="flex h-12 w-full p-0.5">
                <button
                    onClick={() => {
                        if (type === 'best_time_to_post' || type === 'followers_online') {
                            mixPanelSchedulerNewPost('time_slot');
                        } else {
                            mixPanelSchedulerNewPost('generic_slot');
                        }
                        onClick(hour);
                    }}
                    data-testid="empty-slot"
                    className={`group relative flex w-full items-center justify-center overflow-hidden rounded-m ${slotStyles[type].current}`}>
                    {slotStyles[type].content}
                    {!notEditable && (
                        <Icon
                            icon="plus"
                            data-testid="empty-slot-add-icon"
                            className="hidden text-sm text-white group-hover:inline-block"
                        />
                    )}
                    <TimeSlotIcon isActive={events.time_slot} count={events.time_slot_count} />
                </button>
            </div>
        </Tooltip>
    );
};

EmptySlot.propTypes = {
    isPastSlot: PropTypes.bool.isRequired,
    events: PropTypes.object.isRequired,
    tooltipContent: PropTypes.string,
    notEditable: PropTypes.bool,
    onClick: PropTypes.func,
    hour: PropTypes.number
};

export default EmptySlot;
